import { DeliveryMethod } from "../../../utils/types";
import { useCompanyDetails } from "../../../../../hooks/useCompanyDetails";
import { getBusinessOrderEmail } from "../../../../../utils/businessOrderEmail";

type DeliveryOptionsProps = {
  deliveryMethod: DeliveryMethod;
  onChange: (deliveryMethod: DeliveryMethod) => void;
  freeDeliveryThreshold: number;
  businessDeliveryPrice: number;
};

function DeliveryOptions({
  deliveryMethod,
  onChange,
  freeDeliveryThreshold,
  businessDeliveryPrice,
}: DeliveryOptionsProps) {
  const { data: companyDetails } = useCompanyDetails();
  const businessOrderEmail = getBusinessOrderEmail(companyDetails);

  return (
    <div className="delivery-options-header">
      <h2>Delivery options</h2>
      <div className="delivery-options">
        <label>
          <input
            type="radio"
            className="delivery-option-radiobutton"
            name="delivery-options"
            value="pickup"
            checked={deliveryMethod === DeliveryMethod.Pickup}
            onChange={(e) => onChange(e.target.value as DeliveryMethod)}
          />
          Pick up at Alnarp's Farm <span className="gray-text">0 kr</span>
        </label>

        <label>
          <input
            type="radio"
            className="delivery-option-radiobutton"
            name="delivery-options"
            value="shipping"
            checked={deliveryMethod === DeliveryMethod.Shipping}
            onChange={(e) => onChange(e.target.value as DeliveryMethod)}
          />
          Delivery to company address.{" "}
          <span className="gray-text">
            (Free delivery when subtotal is at least {freeDeliveryThreshold} kr.
            Below that, delivery cost is {businessDeliveryPrice} kr. )
          </span>
        </label>
        <div className="info-bubble">
          {deliveryMethod === DeliveryMethod.Pickup ? (
            <p>
              * Pickup is made during your agreed upon pickup day and time. (See
              contract.) If you have any questions, feel free to contact us at{" "}
              <a
                href={`mailto:${businessOrderEmail}`}
                style={{ color: "white" }}
              >
                {businessOrderEmail}
              </a>
              !
            </p>
          ) : (
            <p>
              * Delivery is made during your agreed upon delivery day and time.
              (See contract.) If you have any questions, feel free to contact us
              at{" "}
              <a
                href={`mailto:${businessOrderEmail}`}
                style={{ color: "white" }}
              >
                {businessOrderEmail}
              </a>
              !
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default DeliveryOptions;
